/**
 * Z-index for feature release tours.
 * This is lower than FREE_TRIAL_MODAL_Z_INDEX to ensure modals take priority.
 */
export const FEATURE_RELEASE_TOUR_Z_INDEX = 900;
